import { initialize as initializeDataTypes, Kinds, TypeInfos } from "../../lib/data/model/data-types.js";

const TYPE_DEFS = [
        ['Setting', 'Nastavení', null, null, null],
        ['TimeZone', 'Časová zóna', null, null, 'core/time-zones/codelist'],
        ['User', 'Uživatel', null, null, 'core/users/codelist'],
        ['Privilege', 'Oprávnění', null, null, 'core/privileges/codelist'],
        ['Role', 'Role', null, null, 'core/roles/codelist'],
        ['RolePrivilege', 'Oprávnění role', null, null, null],
        ['UserRole', 'Role uživatele', null, null, null],
        ['Permission', 'Přístupové oprávnění', null, null, 'core/permissions/codelist'],
        ['FolderType', 'Typ složky', null, null, 'core/folder-types/codelist'],
        ['Folder', 'Složka', null, null, null],
        ['FolderPermission', 'Přístupové právo složky', null, null, null],
        ['FileType', 'Typ souboru', null, null, 'core/file-types/codelist'],
        ['File', 'Soubor', null, null, null],
        ['Workflow', 'Workflow', null, null, null],
        ['WorkflowStatus', 'Stav workflow', null, null, null],
        ['WorkflowTransition', 'Přechod workflow', null, null, null],
        ['WorkflowTransitionPrivilege', 'Oprávnění přechodu workflow', null, null, null],
        ['Person', 'Osoba', null, null, null],
        ['Address', 'Adresa', null, null, null],
        ['Customer', 'Zákazník', null, null, 'customers/customers/codelist'],
        ['CustomerPerson', 'Osoba zákazníka', null, null, null],
        ['CustomerAddress', 'Adresa zákazníka', null, null, null],
        ['Employee', 'Zaměstnanec', 'Informace o zaměstnanci.\n\nOdděleno od uživatelských účtů ze dvou důvodů:\n- Informace o zaměstnanci může měnit pouze zaměstnavatel. \n- V případě odchodu zaměstnance je možné uživatelský účet smazat a přitom zachovat historické záznamy o \nvykonané práci.', null, 'employees/employees/codelist'],
        ['EngineFuelType', 'Typ paliva', null, null, 'machines/engine-fuel-types/codelist'],
        ['EngineType', 'Typ stroje', null, null, 'machines/engine-types/codelist'],
        ['GeneratorType', 'Typ generátoru', null, null, 'machines/generator-types/codelist'],
        ['MachineStatus', 'Stav stroje', null, null, 'machines/machine-statuses/codelist'],
        ['Machine', 'Stroj', null, null, 'machines/machines/codelist'],
        ['WorkHoliday', 'Státní svátek', null, null, 'work/work-holidays/codelist'],
        ['WorkGroup', 'Skupina práce', null, null, 'work/work-groups/codelist'],
        ['WorkActivity', 'Pracovní aktivita', null, null, 'work/work-activities/codelist'],
        ['WorkType', 'Typ práce', null, null, 'work/work-types/codelist'],
        ['WorkActivityAction', 'Akce k typu aktivity', null, null, null],
        ['WorkContract', 'Zakázka', 'Pracovní zakázka\nSlouží pro plánování budoucích pracovních zakázek. Popisuje pouze stroj a připojuje detaily, co je\nnutné udělat.', null, null],
        ['WorkSchedule', 'Rozpis práce', 'Plánovaný rozpis práce. \nEviduje budoucí činnosti pracovníka v daném dni.', null, null],
        ['WorkEvent', 'Pracovní události', 'Výkaz o práci provedené daným pracovníkem v daném časovém období.', null, null],
];

let $initialized = false;

export function initialize() {

    if ($initialized)
        return;

    initializeDataTypes();

    TYPE_DEFS.forEach((def, index) => {
        let type = {
            id: `${Kinds.Ref}:${def[0]}`,
            name: def[0],
            kind: Kinds.Ref,
            label: def[1],
            description: def[2],
            hint: def[3],
            valuesEndpoint: def[4],
        };
        TypeInfos.push(type);
    });

    $initialized = true;

};
